module.exports = __webpack_public_path__ + "static/img/oillight3.671e17ca.png";